export class KmHistory {
    public id: string;
    public creationDate: string;
    public loadDate: string;
    public km: number;
    public service: string;
    public comments: string;

    public loadDateSince: string;
    public loadDateUntil: string;

    constructor(other ?: KmHistory) {
        if (other) {
            this.id = other.id;
            this.creationDate = other.creationDate;
            this.loadDate = other.loadDate;
            this.km = other.km;
            this.service = other.service;
            this.comments = other.comments;

            this.loadDateSince = other.loadDateSince;
            this.loadDateUntil = other.loadDateUntil;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/kmHistory.ts
 **/